export const currencyList = [
  { name: "United States Dollar", symbol: "$" },
  { name: "Euro", symbol: "€" },
  { name: "British Pound", symbol: "£" },
  { name: "Indian Rupee", symbol: "₹" },
  { name: "Japanese Yen", symbol: "¥" },
  { name: "Australian Dollar", symbol: "A$" },
  { name: "Canadian Dollar", symbol: "C$" },
  { name: "Swiss Franc", symbol: "CHF" },
  { name: "Chinese Yuan", symbol: "¥" },
  { name: "Swedish Krona", symbol: "kr" },
  // Add more currencies as needed
];
